import React from 'react'

import Tooltip from 'common/components/dataDisplay/Tooltip'
import Icon from 'common/components/general/Icon'

import { Ballot, Coins, Envelope, PaperPlane, Tasks, UsdCircle, UserCheck, UserPlus, Users } from './CardIcons'

import './Card.less'

export enum SignType {
  Percentage = 1,
  Dollar = 2,
  None = 3,
}

export interface AllowanceCard {
  id: number
  description: string
  tooltipInfo?: string
  icon: string
  amount?: number | string
  info?: boolean
  signType?: SignType
  position?: 'left' | 'right'
}

const getSign = (type: SignType) => {
  switch (type) {
    case SignType.Dollar:
      return <span></span>
    case SignType.Percentage:
      return <span>%</span>
    case SignType.None:
      return null
    default:
      return null
  }
}

export const AllowanceCard: React.FC<AllowanceCard> = (props) => {
  const getIcon = (icon: string) => {
    switch (icon) {
      case 'ballot-check':
        return <Ballot color="#12B1D6" />
      case 'tasks':
        return <Tasks color="#12B1D6" />
      case 'usd-circle':
        return <UsdCircle color="#12B1D6" />
      case 'coins':
        return <Coins color="#12B1D6" />
      case 'users-check':
        return <UserCheck color="#12B1D6" />
      case 'user-plus':
        return <UserPlus color="#12B1D6" />
      case 'envelope':
        return <Envelope color="#12B1D6" />
      case 'users':
        return <Users color="#12B1D6" />
      case 'paper-plane':
        return <PaperPlane color="#12B1D6" />
    }
  }
  return (
    <div className="card-wrapper width-100 mb-16">
      <div className="pd-16-24 flex jc-space-between">
        <div className="flex">
          <p className="pr-6">{props.description}</p>
          <div>
            {props.info ? (
              <Tooltip title={props.tooltipInfo} position="right">
                <div className="color-gray-6">
                  <Icon type="far fa-info-circle" fontAwesome /> {``}
                </div>
              </Tooltip>
            ) : null}
          </div>
        </div>
        {getIcon(props.icon)}
      </div>

      {props.position === 'right' ? (
        <p className="pl-24 price">
          {props.amount}
          {props.signType ? getSign(props.signType) : null}
        </p>
      ) : (
        <p className="pl-24 price">
          {props.signType ? getSign(props.signType) : null}
          {props.amount}
        </p>
      )}
    </div>
  )
}
